import React, { FC } from 'react';
import { useField, FieldAttributes } from 'formik';
import { Text, Checkbox } from '@tonic-ui/react';
import { InlineError } from './index';

type CheckboxInputProps = {
  label: string;
  variantColor?: string;
  size?: string;
  disabled?: boolean;
  onCheckboxChange?: (checked) => void;
} & FieldAttributes<Record<string, unknown>>;

const CheckboxInput: FC<CheckboxInputProps> = ({
  label,
  variantColor = 'blue',
  size = 'md',
  disabled = false,
  onCheckboxChange,
  ...rest
}) => {
  const [field, meta, helpers] = useField(rest);
  const { setValue } = helpers;
  const isInvalid = meta.error && meta.touched ? meta.error : '';
  return (
    <>
      <Checkbox
        {...field}
        checked={field.value}
        variantColor={isInvalid ? 'red' : variantColor}
        disabled={disabled}
        size={size}
        onChange={(e) => {
          setValue(e.target.checked, true);
          if (onCheckboxChange) onCheckboxChange(e.target.checked);
        }}
      >
        {label}
      </Checkbox>
      {isInvalid && (
        <Text size="xs" mt="1x">
          <InlineError errorName={isInvalid} />
        </Text>
      )}
    </>
  );
};

export default CheckboxInput;
